import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// Opens the tab asked for in navigation state, e.g. navigate("/JoinUs", { state: { tab: "#two" } }),
// by clicking its link, and (by default) scrolls it into view. Runs on every such navigation
// (location.key changes each time), so asking for the same tab twice still works after the user
// has clicked another tab in between.
// Options:
//   ready    - pass false while the page has not rendered its tabs yet (e.g. still loading)
//   stateKey - which navigation-state field names the tab ("tab" on Join Us, "defaultTab" on Profile)
//   scroll   - scroll the tab into view (default true). Only when the request comes while the page is
//              already open (e.g. a footer click at the bottom of Join Us); a page reached from elsewhere
//              starts at the top as it always has.
export default function useOpenRequestedTab({ ready = true, stateKey = "tab", scroll = true } = {}) {
  const location = useLocation();
  const requested = location.state && location.state[stateKey];
  const arrivalKey = useRef(location.key); // the navigation that brought us to this page

  useEffect(() => {
    if (!ready || !requested) return;
    const tabLink = document.querySelector(`a[href="${requested}"]`);
    if (!tabLink) return;
    tabLink.click();
    if (scroll && location.key !== arrivalKey.current) tabLink.scrollIntoView({ behavior: "smooth", block: "center" });
  }, [ready, requested, scroll, location.key]);
}
